import { PageHeader, Tooltip, message } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import ButtonItem from "../../../Components/ButtonItem";
import TableItem from "../../../Components/TableItem";
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";


class Emergencias extends Component {
    state = {
        loading: false,
        todosFormularios: [],
        mostrarModalFormulario: true,

    };

    componentDidMount() {
        this.cargarFormulariosEmpresa();
    }


    //Función para cargar todos los formularios de la empresa 
    cargarFormulariosEmpresa = async () => {

        await axios
            .post(
                "/formularioAmbulancia/obtenerFormulariosPorEmpresa",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todosFormularios: res.data.formularios,
                        loading: false,
                    });
                } else {
                    message.error('No se pudieron cargar los formularios');
                    this.setState({ loading: false });
                }
            })

    };


    //Funciones para abrir y cerrar los modales
    llenarFormulario = () => {
        this.props.history.push('/panel/llenarFormulario')

    };

    cerrarModalFormulario = () => {
        this.setState({ mostrarModalFormulario: false });
    };
    editarFormulario = (id) => {
        this.props.history.push(`/panel/editarFormulario`, { id });
    };
    verFormularioSoloLectura = (id) => {
        const soloLectura = true;
        this.props.history.push('/panel/editarFormulario', { id, soloLectura });
    };

    render() {

        const columns = [
            {
                title: "Folio Radio Cabina",
                dataIndex: "folioRadioCabina",
                key: "folioRadioCabina",
                buscar: "folioRadioCabina",
                sorter: (a, b) => {
                    if (a.folioRadioCabina < b.folioRadioCabina) {
                        return -1;
                    }
                    if (a.folioRadioCabina > b.folioRadioCabina) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => Number(value),

            },
            {
                title: "Folio Parte de Servicio",
                dataIndex: "folioParteServicio",
                key: "folioParteServicio",
                buscar: "folioParteServicio",
                sorter: (a, b) => {
                    if (a.folioParteServicio < b.folioParteServicio) {
                        return -1;
                    }
                    if (a.folioParteServicio > b.folioParteServicio) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => Number(value),
            },
            {
                title: "Fecha Servicio",
                dataIndex: "fechaservicio",
                key: "fechaservicio",
                buscar: "fechaservicio",
                render: (value) => moment(value).format("DD/MM/YYYY"),
            },
            {
                title: "Hora de recepción de la llamada",
                dataIndex: "horaRecepcionLlamada",
                key: "horaRecepcionLlamada",
                sorter: (a, b) => {
                    if (a.horaRecepcionLlamada < b.horaRecepcionLlamada) {
                        return -1;
                    }
                    if (a.horaRecepcionLlamada > b.horaRecepcionLlamada) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => value ? moment(value).format("HH:mm") : "-",
            },
            {
                title: "Paciente",
                dataIndex: "paciente",
                key: "paciente",
                sorter: (a, b) => {
                    if (a.paciente < b.paciente) {
                        return -1;
                    }
                    if (a.paciente > b.paciente) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => (value) || "",
                width: "200px",

            },
            /*{
                title: "Terapía Intensiva",
                dataIndex: "terapiaIntensiva",
                key: "terapiaIntensiva",
                sorter: (a, b) => {
                    if (a.terapiaIntensiva < b.terapiaIntensiva) {
                        return -1;
                    }
                    if (a.terapiaIntensiva > b.terapiaIntensiva) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => (value) || "",
                width: "150px",
            },*/
            {
                title: "Solicitante del servicio",
                dataIndex: "nombreSolicitante",
                key: "nombreSolicitante",
                sorter: (a, b) => {
                    if (a.nombreSolicitante < b.nombreSolicitante) {
                        return -1;
                    }
                    if (a.nombreSolicitante > b.nombreSolicitante) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => (value) || "",
            },
            /*
            {
                title: "Operador",
                dataIndex: "operador",
                key: "operador",
                sorter: (a, b) => {
                    if (a.operador < b.operador) {
                        return -1;
                    }
                    if (a.operador > b.operador) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => (value) || "",
                width: "200px",
            },*/
            {
                title: "N° de unidad",
                dataIndex: "numeroUnidad",
                key: "numeroUnidad",
                buscar: "numeroUnidad",
                sorter: (a, b) => {
                    if (a.numeroUnidad < b.numeroUnidad) {
                        return -1;
                    }
                    if (a.numeroUnidad > b.numeroUnidad) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => (value) || "",
            },/*
            {
                title: "Duración del servicio",
                dataIndex: "duracionServicio",
                key: "duracionServicio",
                render: (value) => (value) || "",
                width: "150px",
            },*/
            {
                title: "Acción",
                key: "acciones",
                fixed: "right",
                align: "center",
                width: "15%",
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    className: "acciones-sin-hover",
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, index) => {
                    let buttons = [];

                    buttons.push(
                    <Tooltip 
                        title="Editar Formulario" 
                        placement="top" 
                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                    >
                        <ButtonItem
                        key={`editar-${index}`}
                        type="default"
                        size="small"
                        cyan
                        icon={<EditOutlined />}
                        onClick={() => this.editarFormulario(value._id)}
                        >
                        </ButtonItem>
                    </Tooltip>
                    );

                    return <div className="acciones-container">{buttons}</div>;
                },
                }
                /*
                <>
                    {value.estado === 1 ? (
                        <Popconfirm
                            title="¿Estás seguro de deshabilitar esta ubicación?"
                            onConfirm={() => this.deshabilitarUbicacion(value._id)}
                            okText="Sí"
                            cancelText="No"
                        >
                            <CheckCircleOutlined style={{ color: "green" }} />
                        </Popconfirm>
                    ) : (
                        <Popconfirm
                            title="Seguro que quieres habilitar esta ubicación"
                            onConfirm={() => this.habilitarUbicacion(value._id)}
                            okText="Si"
                            cancelText="No"
                        >
                            <StopOutlined style={{ color: "red" }} />
                        </Popconfirm>
                    )}
                </> */
                
            ];

        return (
            <>
                <PageHeader
                    title="Emergencias"
                    subTitle="Formulario de servicio de ambulancia"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            <ButtonItem
                                type="primary"
                                key="llenarFormulario"
                                onClick={this.llenarFormulario}
                                 className="botonAgregar"
                            >
                                Llenar Nuevo Formulario
                            </ButtonItem>
                        </>
                    }
                ></PageHeader>
                <TableItem
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.todosFormularios}
                    columns={columns}
                    pagination={true}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            this.verFormularioSoloLectura(record._id)
                        },
                    })}


                />


            </>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        usuarioId: state.user.id,

    };
};

export default connect(mapStateToProps)(Emergencias);